import { enableProdMode, provideZoneChangeDetection } from '@angular/core';
import * as Sentry from '@sentry/angular';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from '@environment/environment';
import { isAbortedAssetRequest } from '@shared/helpers/sentry.helper';
import { AppModule } from '@references/app.module';
import { isLocalStorageAvailable } from '@shared/helpers/utils.helper';
import { throwError } from 'rxjs';

Sentry.init({
  dsn: environment.SENTRY.DNS,
  beforeSend: (event, hint) => {
    if (environment.ENVIRONMENT === 'development') {
      return null;
    }
    // A static asset the browser never finished fetching is a client-side
    // condition, not a defect. The loaders we own handle it themselves; this
    // catches the paths that do not (e.g. TranslateInLangPipe).
    if (isAbortedAssetRequest(hint && hint.originalException)) {
      return null;
    }
    return event;
  },
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration()
  ],
  // Tracing
  tracesSampleRate: 1.0, //  Capture 100% of the transactions
  // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
  tracePropagationTargets: environment.SENTRY.TRACE_URL,
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  environment: environment.ENVIRONMENT,
  initialScope: (scope) => scope.setTag('app_name', 'references')
});

if (environment.IS_PRODUCTION) {
  enableProdMode();
  isLocalStorageAvailable();
}

platformBrowserDynamic()
  .bootstrapModule(AppModule, { applicationProviders: [provideZoneChangeDetection()], })
  .catch((err: Error) => throwError(err));
